import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { Grid2 as Grid, IconButton, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import ReactHookFormDatePicker from "@components/ReactHookFormDatePicker/ReactHookFormDatePicker";
import CustomLabelInput from "@components/CustomLabelInput";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { PersonFormType } from "@utils/patientFormHelper";

const ResidencyForm: FC<{
  index: number;
  form: UseFormReturn<PersonFormType>;
  onDeleteRow: (index: number) => void;
}> = ({
  form: {
    control,
    register,
    formState: { errors },
  },
  index,
  onDeleteRow,
}) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6, md: 3 }}>
        <CustomLabelInput
          label={t("personForm.residencyLocationInput.label")}
          id={`residencies-${index}-location`}
          required={true}
        >
          <TextField
            {...register(`residencies.${index}.location`, {
              required: true,
            })}
            error={!!errors?.residencies?.[index]?.location}
            id={`residencies-${index}-location`}
            type="text"
            size="small"
            variant="outlined"
            fullWidth
            placeholder={t("personForm.residencyLocationInput.placeholder")}
          />
        </CustomLabelInput>
      </Grid>
      <Grid size={{ xs: 6, md: 4 }}>
        <CustomLabelInput
          label={t("personForm.residencyStartDateInput.label")}
          id={`residencies-${index}-startDate`}
        >
          <ReactHookFormDatePicker
            slotProps={{
              textField: {
                size: "small",
                error: !!errors?.residencies?.[index]?.startDate,
              },
            }}
            id={`residencies-${index}-startDate`}
            controller={{
              name: `residencies.${index}.startDate`,
              control,
              defaultValue: null,
            }}
          />
        </CustomLabelInput>
      </Grid>

      <Grid size={{ xs: 6, md: 4 }}>
        <CustomLabelInput
          label={t("personForm.residencyEndDateInput.label")}
          id={`residencies-${index}-endDate`}
        >
          <ReactHookFormDatePicker
            slotProps={{
              textField: {
                size: "small",
                error: !!errors?.residencies?.[index]?.endDate,
              },
            }}
            id={`residencies-${index}-endDate`}
            controller={{
              name: `residencies.${index}.endDate`,
              control,
              defaultValue: null,
            }}
          />
        </CustomLabelInput>
      </Grid>

      <Grid
        size={{ xs: 3, md: 1 }}
        display="flex"
        alignItems="flex-end"
        marginBottom="5px"
      >
        <IconButton
          color="error"
          size="small"
          onClick={() => onDeleteRow(index)}
        >
          <DeleteOutlineOutlinedIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default ResidencyForm;
